<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-card v-for="req in requests" :key="req.id" class="mb-3">
          <v-card-title class="text-body-1 font-weight-medium d-flex align-center">
            <v-icon :color="statusColor(req.status)" class="mr-2" size="small">
              {{ typeIcon(req.type) }}
            </v-icon>
            {{ typeLabel(req.type) }}
            <v-spacer />
            <v-chip :color="statusColor(req.status)" size="x-small" variant="flat">
              {{ statusLabel(req.status) }}
            </v-chip>
          </v-card-title>
          <v-card-subtitle>
            {{ formatDate(req.created_at) }}
          </v-card-subtitle>
          <v-card-text v-if="req.operator_note" class="text-body-2 pt-0">
            {{ req.operator_note }}
          </v-card-text>
        </v-card>

        <v-card v-if="requests.length === 0">
          <v-card-text class="text-center text-medium-emphasis">
            Нет заявок
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'
import axios from 'axios'
import { useUserStore } from '@/stores/user'
import { API_BASE_URL } from '@/services/api'

interface Request {
  id: number
  type: string
  status: string
  data: any
  created_at: string
  closed_at: string | null
  operator_note: string | null
}

const userStore = useUserStore()
const requests = ref<Request[]>([])

const getPhoneNumber = () => {
  return userStore.state?.context?.user?.phoneNumber?.substring(4) || ''
}

const fetchRequests = async () => {
  const phone = getPhoneNumber()
  if (!phone) return
  try {
    const { data } = await axios.get(`${API_BASE_URL}/requests?phone=${phone}`)
    requests.value = data
  } catch (e) {
    console.error('Error fetching requests:', e)
  }
}

const typeLabel = (type: string) => {
  return { tariff_change: 'Смена тарифа', roaming_enable: 'Включение роуминга', roaming_disable: 'Отключение роуминга' }[type] || type
}

const typeIcon = (type: string) => {
  return type === 'tariff_change' ? 'mdi-sim' : 'mdi-earth'
}

const statusColor = (status: string) => {
  return { open: 'warning', done: 'success', rejected: 'error' }[status] || 'grey'
}

const statusLabel = (status: string) => {
  return { open: 'В обработке', done: 'Выполнена', rejected: 'Отклонена' }[status] || status
}

const formatDate = (dt: string) => {
  if (!dt) return ''
  return new Date(dt).toLocaleString('ru-RU', {
    day: '2-digit', month: '2-digit', year: 'numeric',
    hour: '2-digit', minute: '2-digit'
  })
}

watch(() => userStore.state.value, async (state) => {
  if (state === 'authenticated') {
    await fetchRequests()
  }
}, { immediate: true })
</script>
